import PropTypes from "prop-types";
import React from "react";
import { Alert, Button, ButtonToolbar, Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import genericTranslations from "../../../utils/genericTranslations.js";

const messages = {
  softwarePackage: {
    id: "modules.SoftwarePackage.components.SoftwarePackageForm.softwarePackage",
    description: "Software Package label.",
    defaultMessage: "Software package",
  },
  title: {
    id: "modules.SoftwarePackage.components.SoftwarePackageForm.title",
    description: "Title label",
    defaultMessage: "Application",
  },
  explanation: {
    id: "modules.SoftwarePackage.components.SoftwarePackageForm.explanation",
    description: "Explanation label",
    defaultMessage: "Explanation",
  },
};

const SoftwarePackageForm = ({
  handleChange,
  handleSubmit,
  errors,
  isSubmitting,
  onClickDelete,
  values,
  serverValidationMessage,
}) => {
  return (
    <Form onSubmit={handleSubmit}>
      {serverValidationMessage && (
        <Alert variant="danger">{serverValidationMessage}</Alert>
      )}

      <Form.Group controlId="code" className="mb-3">
        <Form.Label>CI-nr</Form.Label>
        <Form.Control
          type="text"
          autoComplete="off"
          value={values.code}
          onChange={handleChange}
          isInvalid={!values.code}
        />
        <Form.Control.Feedback type="invalid">
          {errors.code}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="title" className="mb-3">
        <Form.Label>
          <FormattedMessage {...messages.title} />
        </Form.Label>
        <Form.Control
          type="text"
          autoComplete="off"
          value={values.title}
          onChange={handleChange}
          isInvalid={!values.title}
        />
        <Form.Control.Feedback type="invalid">
          {errors.title}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="tag" className="mb-3">
        <Form.Label>Tag</Form.Label>
        <Form.Control
          type="text"
          autoComplete="off"
          value={values.tag}
          onChange={handleChange}
          isInvalid={!values.tag}
        />
        <Form.Text style={{ fontStyle: "italic", fontSize: 12 }}>
          E.g. format #tag1
        </Form.Text>
        <Form.Control.Feedback type="invalid">
          {errors.tag}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="information" className="mb-3">
        <Form.Label>
          <FormattedMessage {...messages.explanation} />
        </Form.Label>
        <Form.Control
          type="text"
          autoComplete="off"
          value={values.information}
          onChange={handleChange}
        />
      </Form.Group>

      <hr />

      <Form.Group controlId="formActions" className="mb-3">
        <ButtonToolbar>
          {values.id && (
            <Button variant="danger" className="me-2" onClick={onClickDelete}>
              <FormattedMessage {...genericTranslations.delete} />
            </Button>
          )}
          <Button
            type="submit"
            variant="light"
            disabled={isSubmitting || Object.keys(errors).length > 0}
          >
            <FormattedMessage {...genericTranslations.save} />
          </Button>
        </ButtonToolbar>
      </Form.Group>
    </Form>
  );
};

SoftwarePackageForm.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onClickDelete: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    code: PropTypes.string,
    title: PropTypes.string,
    tag: PropTypes.string,
  }),
  values: PropTypes.shape({
    id: PropTypes.string,
    code: PropTypes.string,
    title: PropTypes.string,
    tag: PropTypes.string,
    information: PropTypes.string,
  }).isRequired,
  serverValidationMessage: PropTypes.string,
};

export default SoftwarePackageForm;
